import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigate, NavLink } from "react-router-dom";
import { QryptLogoLight } from "./ui";
import { useAuth } from "@/context/auth/AuthContext";
import { useEffectiveCustomerId } from "@/hooks/useEffectiveCustomerId";
import { usePermissions } from "@/hooks/usePermissions";
import { usePortalNavigationAccess } from "@/hooks/usePortalNavigationAccess";
import OrganizationSelector from "./ui/header/OrganizationSelector";
import { API_KEYS_PAGE, AUDIT_LOGS_PAGE, CHANGELOGS_PAGE, // CLUSTERS_PAGE,
CONTRACTS_PAGE, DASHBOARD_PAGE, INVOICES_PAGE, ORGANIZATION_PAGE, UTILIZATION_DEEP_DIVE_PAGE } from "@/router/paths";
function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
const Sidebar = ()=>{
    const { logout } = useAuth();
    const { isSuperAdmin, canViewInvoices, canViewContracts, canViewAuditLogs } = usePermissions();
    const { isViewingAllOrgs } = useEffectiveCustomerId();
    const { canAccessPath } = usePortalNavigationAccess();
    const navigate = useNavigate();
    const navigation = [
        ...canAccessPath(DASHBOARD_PAGE) ? [
            {
                name: "Dashboard",
                path: DASHBOARD_PAGE
            }
        ] : [],
        ...canAccessPath(API_KEYS_PAGE) ? [
            {
                name: "API Keys",
                path: API_KEYS_PAGE
            }
        ] : [],
        // { name: "Clusters", path: CLUSTERS_PAGE },
        ...canViewContracts ? [
            {
                name: "Contracts",
                path: CONTRACTS_PAGE
            }
        ] : [],
        //{ name: "Usage", path: USAGE_PAGE },
        ...canAccessPath(UTILIZATION_DEEP_DIVE_PAGE) ? [
            {
                name: "Utilization",
                path: UTILIZATION_DEEP_DIVE_PAGE
            }
        ] : [],
        ...canViewInvoices && canAccessPath(INVOICES_PAGE) ? [
            {
                name: "Invoices",
                path: INVOICES_PAGE
            }
        ] : [],
        ...canViewAuditLogs && canAccessPath(AUDIT_LOGS_PAGE) ? [
            {
                name: "Audit Logs",
                path: AUDIT_LOGS_PAGE
            }
        ] : [],
        {
            name: "Changelogs",
            path: CHANGELOGS_PAGE
        },
        ...!isViewingAllOrgs ? [
            {
                name: "Organization",
                path: ORGANIZATION_PAGE
            }
        ] : []
    ];
    const handleLogout = async ()=>{
        await logout();
        navigate("/login");
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex h-16 shrink-0 items-center gap-4 pt-4 mb-6",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-24",
                        children: /*#__PURE__*/ _jsx(QryptLogoLight, {})
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "border-l border-l-solid border-navy-60 pl-4 text-white text-lg",
                        children: "Portal"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("nav", {
                className: "flex flex-1 flex-col",
                children: /*#__PURE__*/ _jsx("ul", {
                    role: "list",
                    className: "flex flex-1 flex-col gap-y-7",
                    children: /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx("ul", {
                            role: "list",
                            className: "-mx-2 space-y-1",
                            children: navigation.map((item)=>/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(NavLink, {
                                        to: item.path,
                                        className: ({ isActive })=>classNames(isActive ? "bg-[#27337c] text-white" : "text-gray-400 hover:text-white hover:bg-[#27337c]", "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-normal"),
                                        children: item.name
                                    })
                                }, item.name))
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-auto mb-4 flex flex-col gap-y-3",
                children: [
                    isSuperAdmin && /*#__PURE__*/ _jsx("div", {
                        className: "px-2",
                        children: /*#__PURE__*/ _jsx(OrganizationSelector, {})
                    }),
                    /*#__PURE__*/ _jsxs("button", {
                        onClick: handleLogout,
                        className: "text-gray-400 hover:text-white flex items-center gap-2 px-2 py-2 rounded-md hover:bg-[#27337c] transition-colors",
                        children: [
                            /*#__PURE__*/ _jsxs("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "20",
                                fill: "currentColor",
                                viewBox: "0 0 16 16",
                                children: [
                                    /*#__PURE__*/ _jsx("path", {
                                        fillRule: "evenodd",
                                        d: "M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        fillRule: "evenodd",
                                        d: "M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-sm",
                                children: "Logout"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default Sidebar;
